import { ACTIVE_TAB, LOADER_STATUS, FILE_DATA, COMP_DATA } from "./constants";

const initialState = {
    loaderStatus: false,
    activeTab: 1,
    fileData: [],
    compData:[],
}

const itc04PrepareReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
        case FILE_DATA:
            return {
              ...state,
              fileData:action.fileData
            }
        case ACTIVE_TAB:
            return{
                ...state,
                activeTab: action.activeTab
            }
            case COMP_DATA:
              return {
                ...state,
                compData:action.compData
              }
        default: return state
    }
}

export default itc04PrepareReducer;